import React from "react";
import { useDispatch } from "react-redux";
import { setSortingModelVisibility } from "../../Redux/sortingModel/sortingModel.actions";
import {
  OptionsList as StyledOptionsList,
  Option as StyledOption,
  Title,
  Text,
  SubText,
  IconWrapper,
  CustomIcons,
  SortModelIconWrapper,
  HorizontalLine,
} from "./index.styled";
import { ReactComponent as SortByIcon } from "../../Assets/Icons/SortByIcon.svg";
import Info from "../Info";
import { CheckboxContainer } from "../AdvanceFilterComp/index.styled";
import { viewSizeCalculator } from "../../utils";
import { ReactComponent as EditIcon } from "../../Assets/Icons/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/DeleteIcon.svg";
import { ReactComponent as AddSortModel } from "../../Assets/Icons/AddSortModel.svg";

const OptionsList = ({
  options,
  onOptionClick,
  selectedOption,
  customWidth,
  customPadding,
  customBorderRadius,
  top,
  right,
  showTitle,
  isOpen,
  showIcon,
  showCheckbox,
  height,
  isMargin,
  sortOrder = "desc",
  isSortingDisabled = true,
  setOptions,
  setSortOrder = () => {},
  onEditClick = () => {},
  isSelectModelVisible = false,
  setIsSelectModelVisible = () => {},
  isSelectModelOption = false,
  showDivider = true,
}) => {
  const dispatch = useDispatch();
  const handleSortClick = (e) => {
    e.stopPropagation();
  };

  const toggleSortOrder = () => {
    if (!isSortingDisabled) {
      setSortOrder((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    }
  };

  const handleDeleteClick = (event, option) => {
    event.stopPropagation(); // Prevent parent click event

    // Filter out the deleted option
    const updatedData = options.filter((item) => item.value !== option.value);

    const storedData = JSON.parse(localStorage.getItem("searchHistory"));
    const updatedDataToRestore = storedData.filter(
      (item) => item.id !== option.value?.id,
    );

    // remove localStorage data
    localStorage.removeItem("searchHistory");

    // Save back to localStorage
    localStorage.setItem("searchHistory", JSON.stringify(updatedDataToRestore));

    // If using state, update UI (Assuming options is stored in state)
    setOptions(updatedData);
  };

  return (
    <StyledOptionsList
      customWidth={customWidth}
      customPadding={customPadding}
      top={top}
      right={right}
      isOpen={isOpen}
      height={height}
    >
      {showTitle && (
        <Title onClick={handleSortClick}>
          <Text>{showTitle}</Text>
          {showIcon && (
            <Info
              showArrow={false}
              config={{
                tooltipText: isSortingDisabled
                  ? "Select sorting parameter"
                  : sortOrder === "desc"
                    ? "Sort in Ascending Order"
                    : "Sort in Descending Order",
                position: "top",
              }}
              position="start"
            >
              <IconWrapper
                sortOrder={sortOrder}
                onClick={toggleSortOrder}
                style={{
                  cursor: isSortingDisabled ? "not-allowed" : "pointer",
                  opacity: isSortingDisabled ? 0.5 : 1,
                }}
              >
                <SortByIcon />
              </IconWrapper>
            </Info>
          )}
        </Title>
      )}
      {options.map((option) => (
        <StyledOption
          key={
            option?.provider_number ? `${option.provider_number}` : option.value
          }
          onClick={(e) => {
            onOptionClick(option);
            e.stopPropagation();
          }}
          isSelected={
            showCheckbox
              ? selectedOption?.includes(option.value)
              : selectedOption === option.value
          }
          customBorderRadius={customBorderRadius}
          isMargin={isMargin}
        >
          <div>
            {option.label}
            {option.location && <SubText>{option.location}</SubText>}
          </div>
          {showCheckbox && (
            <CheckboxContainer>
              <input
                id={option.label}
                style={{
                  cursor: "pointer",
                  accentColor: "#F96250",
                  width: viewSizeCalculator(1.063),
                  height: viewSizeCalculator(1.063),
                }}
                type="checkbox"
                checked={showCheckbox && selectedOption?.includes(option.value)}
                onChange={() => onOptionClick(option)}
                onClick={(e) => e.stopPropagation()}
              />
            </CheckboxContainer>
          )}
          {option.customSearch && (
            <CustomIcons parent="&">
              <Info
                showArrow={false}
                config={{
                  tooltipText: "Edit",
                  position: "top",
                }}
              >
                <EditIcon
                  onClick={(e) => {
                    onEditClick(option);
                    e.stopPropagation();
                  }}
                />
              </Info>
              <Info
                showArrow={false}
                config={{
                  tooltipText: "Delete",
                  position: "top",
                }}
              >
                <DeleteIcon onClick={(e) => handleDeleteClick(e, option)} />
              </Info>
            </CustomIcons>
          )}
        </StyledOption>
      ))}
      
      {isSelectModelOption && (
        <>
          {showDivider && <HorizontalLine />}
          <StyledOption
            customBorderRadius={customBorderRadius}
            isMargin={isMargin}
            isSortModel={true}
            onClick={() => dispatch(setSortingModelVisibility(true))}
          >
            <SortModelIconWrapper>
              <AddSortModel />
              Create Sort Models
            </SortModelIconWrapper>
          </StyledOption>
        </>
      )}
    </StyledOptionsList>
  );
};

export default OptionsList;
